import React from 'react';
import PropTypes from 'prop-types';

/** renders children inside of a flex containers */
const DisplayConfiguration = ({ additionalStyles = [], children, data={}, styles = [], className="" }) => {

  const dataProps = {};
  if (data.objectId) {
    dataProps['data-object-id'] = data.objectId;
  }
  if (data.objectType) {
    dataProps['data-object-type'] = data.objectType;
  }
  if (data.componentType) {
    dataProps['data-component-type'] = data.componentType;
  } else {
    dataProps['data-component-type'] = 'display-configuration';
  }

  return (
    <div {...dataProps} className="display-config-container">
      {React.Children.toArray(children).slice(0, styles.length).map((child, index) => {
        const style = { ...styles[index], ...additionalStyles[index] };
        return (
          <div style={style} key={child.key || index} className={className}>
            {child}
          </div>
        );
      })}
    </div>
  );
}

DisplayConfiguration.propTypes = {
  additionalStyles: PropTypes.arrayOf(PropTypes.object),
  children: PropTypes.node,
  className: PropTypes.string,
  data: PropTypes.object,
  styles: PropTypes.arrayOf(PropTypes.object)
};

export default DisplayConfiguration;
